import { render, staticRenderFns } from "./cadcontas.vue?vue&type=template&id=5b18e6de&"
import script from "./cadcontas.vue?vue&type=script&lang=js&"
export * from "./cadcontas.vue?vue&type=script&lang=js&"
import style0 from "./cadcontas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports